import React from 'react';
import PropTypes from 'prop-types';

const VideoStatus = ({ isLoading }) => {
	if (!isLoading) return null;

	return (
		<div className="video-status video-status-loading" role="status">
			<span className="video-status-spinner" aria-hidden="true" />
		</div>
	);
};

VideoStatus.propTypes = {
	isLoading: PropTypes.bool
};

VideoStatus.defaultProps = {
	isLoading: false
};

export default VideoStatus;
